import { render } from "./CartTotal.vue?vue&type=template&id=2bba0ac0&scoped=true"
import script from "./CartTotal.vue?vue&type=script&lang=js"
export * from "./CartTotal.vue?vue&type=script&lang=js"

import "./CartTotal.vue?vue&type=style&index=0&id=2bba0ac0&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bba0ac0"]])

export default __exports__